import { useContext } from 'react'
import { WindowManagerContext, type WindowManagerContextType } from './window-manager-context'

export function useWindowManager(): WindowManagerContextType {
  const ctx = useContext(WindowManagerContext)
  if (!ctx) throw new Error('useWindowManager must be used within WindowManagerProvider')
  return ctx
}
